import { useState } from "react";
import MainLayout from "@/components/layout/MainLayout";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { getPlans, getCurrentExchangeRate } from "@/integrations/supabase/services";
import PlanCard from "@/components/plans/PlanCard";
import { useAuth } from "@/context/AuthContext";

const PlansOperator = () => {
  const [search, setSearch] = useState("");
  const { profile } = useAuth();
  
  const { data: plans = [], isLoading: plansLoading } = useQuery({
    queryKey: ['plans', profile?.branch_id],
    queryFn: () => getPlans(profile?.branch_id),
  });

  const { data: exchangeRate } = useQuery({
    queryKey: ['current-exchange-rate'],
    queryFn: getCurrentExchangeRate,
  });
  
  const filteredPlans = plans.filter(
    (plan) =>
      plan.name.toLowerCase().includes(search.toLowerCase()) &&
      plan.active // Solo mostrar planes activos para operadores
  );

  return (
    <MainLayout>
      <div className="space-y-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <h1 className="text-2xl font-bold text-gray-800">Planes</h1>
        </div>

        <div className="flex flex-col md:flex-row gap-4">
          <div className="relative flex-1">
            <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-gray-500" />
            <Input
              placeholder="Buscar planes..."
              className="pl-8"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>

        {plansLoading ? (
          <div className="flex justify-center items-center h-32">
            <div className="text-gray-500">Cargando planes...</div>
          </div>
        ) : filteredPlans.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-gray-500">No se encontraron planes disponibles.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredPlans.map((plan) => (
              <PlanCard 
                key={plan.id} 
                plan={plan} 
                exchangeRate={exchangeRate}
              />
            ))}
          </div>
        )}
      </div>
    </MainLayout>
  );
};

export default PlansOperator;
